import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";
import {
  successMessage,
  errorMessage,
  capitalizeString,
  warningMessage,
  delete_RecordWithoutApi,
} from "../CommonFunctions";

import CustomSelect from "../../../CustomControls/CustomSelect";
import { SVGICON } from "../../../constant/theme";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import {
  POST_GetMPTMaterialDetailByID,
  POST_MPTMaterialInsert,
  POST_MPTMaterialUpdate,
} from "../../../helpers/url_helper";

const AddMPTMaterial = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { PrimaryIdParam } = useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  useEffect(() => {
    if (PrimaryIdParam) {
      getMPTMaterialDetailByID();
    }
  }, []);

  const getMPTMaterialDetailByID = () => {
    setIsLoading(true);
    post(POST_GetMPTMaterialDetailByID, {
      MPTMaterialIDEncrypt: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({
    MPTMaterial: Yup.string().trim().required("Material is required field"),
    ManufacturerOfPowder: Yup.string()
      .trim()
      .required("Manufacturer Of Powder is required field"),
    BatchNo: Yup.string().trim().required("Batch No is required field"),
    ManufacturerDate: Yup.string()
      .trim()
      .required("Manufacturer Date is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      MPTMaterialIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      MPTMaterial: "",
      ManufacturerOfPowder: "",
      BatchNo: "",
      ManufacturerDate: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { MPTMaterialIDEncrypt },
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);

    const payload = {
      ...values,
      ManufacturerDate: values?.ManufacturerDate
        ? moment(values?.ManufacturerDate)
            .format("YYYY-MM-DD")
            .replace(/^\-/, "")
        : "",
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };
    post(
      PrimaryIdParam ? POST_MPTMaterialUpdate : POST_MPTMaterialInsert,
      payload
    )
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/mptmaterial");
          }, 1000);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} MPT Material
              </h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={3}>
                      <Field
                        type="text"
                        label="Material"
                        name="MPTMaterial"
                        placeholder={`Enter Material`}
                        component={CustomInput}
                        maxLength={250}
                        required
                        autoFocus
                        onChange={(e) => {
                          formik.setFieldValue(
                            "MPTMaterial",
                            capitalizeString(e)
                          );
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="text"
                        label="Manufacturer Of Powder"
                        name="ManufacturerOfPowder"
                        placeholder={`Enter Manufacture rOf Powder`}
                        component={CustomInput}
                        maxLength={250}
                        required
                        onChange={(e) => {
                          formik.setFieldValue(
                            "ManufacturerOfPowder",
                            capitalizeString(e)
                          );
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="text"
                        label="Batch No"
                        name="BatchNo"
                        placeholder={`Enter Batch No`}
                        component={CustomInput}
                        maxLength={250}
                        required
                        onChange={(e) => {
                          formik.setFieldValue("BatchNo", capitalizeString(e));
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Manufacturer Date"
                        name={"ManufacturerDate"}
                        placeholder={"Select Manufacturer Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                        }}
                        required
                      />
                    </Col>
                  </Row>

                  <hr className="mt-1 mb-2"></hr>
                  <button type="submit" className="btn btn-primary btn-sm me-2">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default AddMPTMaterial;
